<div class="carprice_box" *ngIf="!car.sold">
  <div class="carprice fixedprice flex_layout" [ngClass]="{ 'discountcarprice': car.previousPrice}">
    <div class="pricelabel" *ngIf="lang==='ja'">車両価格</div>
    <div *ngIf="car.previousPrice" class="pricedata">
      <span class="regularprice"><span class="previous_price" [innerHTML]="car.previousPrice | priceFormat: ' pricenum': 'pricecur'"></span></span>
      <span class="discountprice"><span class="current_price" [innerHTML]="car.price | priceFormat: ' pricenum': 'pricecur'"></span></span>
    </div>
    <div *ngIf="!car.previousPrice" class="pricedata">
      <span class="current_price" [innerHTML]="car.price | priceFormat: ' pricenum': 'pricecur'"></span>
    </div>
  </div>
</div>
